export const staticConfig = {
  '51wl': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/3.png',
    FavTitle: '搜索排名',
    filing: '皖ICP备18001927号-16',
  },
  'fengyin': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/3.png',
    FavTitle: '云视搜索',
    filing: '蜀ICP备2024055338号-1'
  },
  'juyuai': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/3.png',
    FavTitle: '巨宇AI获客',
    filing: '浙ICP备12013743号-16'
  },
  'qiteng518': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/3.png',
    FavTitle: '剪辑系统',
    filing: '津ICP备2022003066号-6'
  },
  'tui55': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png',
    Logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/2.png',
    Background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/3.png',
    FavTitle: '千里马AI获客',
    filing: '渝ICP备13002463号-18'
  },
}
